document.addEventListener('DOMContentLoaded', function() {
  // Cart form page functionality
  
  // Function to set loading state on cart items grid
  function setCartLoadingState(isLoading) {
    const cartGrid = document.querySelector('.cart-items-grid');
    if (cartGrid) {
      if (isLoading) {
        cartGrid.style.opacity = '0.5';
        cartGrid.style.pointerEvents = 'none';
        cartGrid.style.filter = 'grayscale(50%)';
      } else {
        cartGrid.style.opacity = '1';
        cartGrid.style.pointerEvents = 'auto';
        cartGrid.style.filter = 'none';
      }
    }
  }
  
  // Function to verify max value with logging
  function verifyMax(input, isMaxReached) {
    // Get the closest increaseQty button from the input
    const productRow = input.closest('.details-qty');
    const increaseBtn = productRow?.querySelector('.increaseQty');
    
    // Check if isMaxReached is true and disable/enable the increaseBtn accordingly
    if (increaseBtn) {
      if (isMaxReached) {
        increaseBtn.disabled = true;
      } else {
        increaseBtn.disabled = false;
      }
    }
    
    //return increaseBtn;
  }
  
  // Add event listeners for all decrease quantity buttons
  const decreaseButtons = document.querySelectorAll('.decreaseQty');
  decreaseButtons.forEach(button => {
    
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const qtyInput = this.closest('.details-qty').querySelector('input[data-cart-key]');
      if (qtyInput) {
        const maxValue = parseInt(qtyInput.max, 10);
        const currentValue = parseInt(qtyInput.value, 10) || 0;
        updateQuantity(qtyInput, false);
        verifyMax(qtyInput, currentValue-1 >= maxValue);
      }
    });
  });

  // Add event listeners for all increase quantity buttons
  const increaseButtons = document.querySelectorAll('.increaseQty');
  increaseButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const qtyInput = this.closest('.details-qty').querySelector('input[data-cart-key]');
      if (qtyInput) {
        const currentValue = parseInt(qtyInput.value, 10) || 0;
        const maxValue = parseInt(qtyInput.max, 10);
        if (maxValue && currentValue >= maxValue) {
          qtyInput.value = maxValue;
        } else {
          updateQuantity(qtyInput, true);
        }
        verifyMax(qtyInput, currentValue+1 >= maxValue);
      }
    });
  });
  
  // Add event listeners for delete action buttons
  const deleteButtons = document.querySelectorAll('.action-delete');
  deleteButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      if (confirm('Are you sure you would like to remove this item from the shopping cart?')) {
        // User confirmed deletion, proceed with the original action
        const href = this.getAttribute('href');
        if (href) {
          window.location.href = href;
        }
      }
      // If user cancels, do nothing
    });
  });
  
  // Add event listeners for quantity input changes
  const quantityInputs = document.querySelectorAll('input[name^="updates["]');
  quantityInputs.forEach(input => {
    // Add keydown event listener to prevent Enter from submitting form
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault(); // Prevent form submission
        e.stopPropagation();
        
        const qtyInput = e.target;
        const itemKey = qtyInput.dataset.cartKey;
        
        if (itemKey) {
          // Get the new quantity value and max value
          let newQuantity = parseInt(qtyInput.value, 10) || 0;
          const maxValue = parseInt(qtyInput.max, 10);
          const oldQuantity = parseInt(qtyInput.dataset.originalQuantity || qtyInput.defaultValue || 0, 10);
          
          // Check if new quantity exceeds max
          if (maxValue && newQuantity > maxValue) {
            newQuantity = maxValue;
            qtyInput.value = maxValue;
          }
          
          // Only update if quantity has actually changed
          if (newQuantity !== oldQuantity) {
            updateQuantityDirect(qtyInput, newQuantity);
          }
          verifyMax(qtyInput, newQuantity+1 >= maxValue);
        }
      }
    });
    
    input.addEventListener('change', function(e) {
      e.preventDefault();
      const qtyInput = e.target;
      const itemKey = qtyInput.dataset.cartKey;
      
      if (itemKey) {
        // Get the new quantity value and max value
        let newQuantity = parseInt(qtyInput.value, 10) || 0;
        const maxValue = parseInt(qtyInput.max, 10);
        const oldQuantity = parseInt(qtyInput.dataset.originalQuantity || qtyInput.defaultValue || 0, 10);
        
        // Check if new quantity exceeds max
        if (maxValue && newQuantity > maxValue) {
          newQuantity = maxValue;
          qtyInput.value = maxValue;
        }
        
        // Only update if quantity has actually changed
        if (newQuantity !== oldQuantity) {
          updateQuantityDirect(qtyInput, newQuantity);
        }
        verifyMax(qtyInput, newQuantity+1 >= maxValue);
      }
    });
  });
  
  // Update quantity function (similar to mini-cart)
  async function updateQuantity(input, increase = true) {
    const qtyInput = input;

    const itemKey = qtyInput.dataset.cartKey;

    if (!itemKey) return;
    
    let quantity = parseInt(qtyInput.value, 10);
    if (increase) {
      quantity += 1;
    } else {
      quantity -= 1;
    }
    
    if (quantity < 0) {
      quantity = 0;
    }
    
    // Check if quantity is 0 and ask for confirmation
    if (quantity === 0) {
      if (!confirm('Are you sure you would like to remove this item from the shopping cart?')) {
        // User cancelled, don't update
        return;
      }
    }
    
    qtyInput.value = quantity;

    // Set loading state
    setCartLoadingState(true);

    // Disable buttons during update
    const productRow = qtyInput.closest('tr, .cart-item, .product-item');
    const increaseBtn = productRow?.querySelector('.increaseQty');
    const decreaseBtn = productRow?.querySelector('.decreaseQty');
    if (increaseBtn) increaseBtn.disabled = true;
    if (decreaseBtn) decreaseBtn.disabled = true;

    // POST request to update cart
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          updates: {
            [itemKey]: quantity
          }
        })
      });
      
      if (!response.ok) throw new Error('Network response was not ok');
      
      const cart = await response.json();
      
      // Update header cart count
      const headerCartCountElements = document.querySelectorAll('span[data-header-cart-count]');
      headerCartCountElements.forEach(element => {
        if (cart.item_count > 0) {
          element.textContent = cart.item_count;
          element.style.display = '';
        } else {
          element.style.display = 'none';
        }
      });
      
      // Find the updated item in the cart and update its price display
      const updatedItem = cart.items.find(item => item.key === itemKey);

      if (updatedItem) {
        updateQuantities(itemKey, updatedItem.line_price);
      }
      
      // Update the original quantity data attribute
      qtyInput.dataset.originalQuantity = quantity;
      
      // Optionally reload the page or update cart display
      if (quantity === 0) {
        // Reload page when item is removed
        window.location.reload();
      }
      
    } catch (error) {
      console.error('Error updating cart:', error);
      // Revert the input value on error
      qtyInput.value = increase ? quantity - 1 : quantity + 1;
    } finally {
      // Remove loading state
      setCartLoadingState(false);
      
      // Re-enable buttons
      if (increaseBtn) increaseBtn.disabled = false;
      if (decreaseBtn) decreaseBtn.disabled = false;
    }
  }

  // Update quantity directly (for onchange events)
  async function updateQuantityDirect(qtyInput, newQuantity) {
    const itemKey = qtyInput.dataset.cartKey;
    
    if (!itemKey) return;
    
    // Prevent double execution
    if (qtyInput.dataset.updating === 'true') {
      return;
    }

    // Check if quantity is 0 and ask for confirmation
    if (newQuantity === 0) {
      if (!confirm('Are you sure you would like to remove this item from the shopping cart?')) {
        // User cancelled, revert to original quantity
        qtyInput.value = qtyInput.dataset.originalQuantity || qtyInput.defaultValue || 1;
        return;
      }
    }
    
    // Set updating flag
    qtyInput.dataset.updating = 'true';

    // Set loading state
    setCartLoadingState(true);

    // Disable buttons during update
    const productRow = qtyInput.closest('tr, .cart-item, .product-item');
    const increaseBtn = productRow?.querySelector('.increaseQty');
    const decreaseBtn = productRow?.querySelector('.decreaseQty');
    if (increaseBtn) increaseBtn.disabled = true;
    if (decreaseBtn) decreaseBtn.disabled = true;

    // POST request to update cart
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          updates: {
            [itemKey]: newQuantity
          }
        })
      });
      
      if (!response.ok) throw new Error('Network response was not ok');
      
      const cart = await response.json();
      
      // Update header cart count
      const headerCartCountElements = document.querySelectorAll('span[data-header-cart-count]');
      headerCartCountElements.forEach(element => {
        if (cart.item_count > 0) {
          element.textContent = cart.item_count;
          element.style.display = '';
        } else {
          element.style.display = 'none';
        }
      });
      
      // Find the updated item in the cart and update its price display
      const updatedItem = cart.items.find(item => item.key === itemKey);
      if (updatedItem) {
        updateQuantities(itemKey, updatedItem.line_price);
      }
      
      // Update the original quantity data attribute
      qtyInput.dataset.originalQuantity = newQuantity;
      
      // Reload page if item is removed
      if (newQuantity === 0) {
        window.location.reload();
      }
      
    } catch (error) {
      console.error('Error updating cart:', error);
      // Revert the input value on error
      qtyInput.value = qtyInput.dataset.originalQuantity || qtyInput.defaultValue || 0;
    } finally {
      // Remove loading state
      setCartLoadingState(false);
      
      // Clear updating flag
      qtyInput.dataset.updating = 'false';
      
      // Re-enable buttons
      if (increaseBtn) increaseBtn.disabled = false;
      if (decreaseBtn) decreaseBtn.disabled = false;
    }
  }

  // Update quantities function - updates price and other elements
  function updateQuantities(key, linePrice) {
    // Update the price element with id price_+key
    const priceElement = document.getElementById(`price_${key}`);
    if (priceElement) {
      priceElement.textContent = formatMoney(linePrice, window.KROWN?.settings?.shop_money_format);
    }
    
    // Optionally refresh cart totals section
    fetch(`${window.location.pathname}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Update AjaxCartSubtotal content
        const newSubtotal = doc.querySelector('#AjaxCartSubtotal');
        const currentSubtotal = document.querySelector('#AjaxCartSubtotal');
        
        if (newSubtotal && currentSubtotal) {
          currentSubtotal.innerHTML = newSubtotal.innerHTML;
        }
        
        // Also update cart footer if it exists
        const newFooter = doc.querySelector('.cart-footer');
        const currentFooter = document.querySelector('.cart-footer');
        if (newFooter && currentFooter) {
          currentFooter.innerHTML = newFooter.innerHTML;
        }
      })
      .catch(error => {
        console.error('Error updating cart content:', error);
      });
  }
});